import MDModal from "components/MDModal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useContext, useEffect, useState } from "react";
import DataTable from "examples/Tables/DataTable";
import DefaultCell from "examples/Tables/DataTable/components/DefaultCell";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { ModalContext } from "context/ModalContext";
import { LoginFormContext } from "context/LoginFormContext";
import { MODULES } from "helpers/constant";
import UpdateStatus from "components/MDUpdateStatus";
import MDActionButton from "components/MDActionButton";
import { SEARCH_INPUT_TYPES } from "helpers/constant";
import ReserveDateForm from "./Form";
import moment from "moment";
import { addOnsList } from "Apis/addOns";
import { AddOnsContext } from "context/AddOnsContext";
import AddOnsForm from "./Form";
import { getAddOnsById } from "Apis/addOns";
import { deleteAddOnsById } from "Apis/addOns";
import { updateAddOns } from "Apis/addOns";

const AddOns = () => {
  const { showMessageNotification, setOpen, formIsEdit, setFormIsEdit } = useContext(ModalContext);
  const {
    setNotification,
    modules,
    getModuleAccess,
    access,
    isLoading,
    setIsLoading,
    filterLoader,
    setFilterLoader,
  } = useContext(LoginFormContext);
  const { setEditData } = useContext(AddOnsContext);
  const [addOnsData, setAddOnsData] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [defaultFilter, setDefaultFilter] = useState({
    currentPage: 1,
    itemsPerPage: 10,
    sortBy: [{ id: "id", value: "desc" }],
  });
  const handleEditDelete = async (row, type) => {
    if (type === "Edit") {
      setFilterLoader(false);
      let response = await getAddOnsById(row.id);
      if (response?.status === 200) {
        setEditData(response?.data?.data);
        setOpen(true);
        setFormIsEdit(true);
      }
    }

    if (type === "Delete") {
      showMessageNotification({
        title: "Are you sure?",
        text: "You want to delete this advertisement!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result?.isConfirmed) {
          let deleteResponse = await deleteAddOnsById(row?.id);
          if (deleteResponse?.status === 200) {
            setFilterLoader(false);
            setOpen(false);
            addOnsData?.length === 1 && setDefaultFilter({ ...defaultFilter, currentPage: 1 });
            getAddOnsList();
            setNotification({
              color: "success",
              icon: "check",
              title: "Success",
              content: deleteResponse?.data?.message,
              open: true,
            });
          } else {
            setNotification({
              color: "error",
              icon: "check",
              title: "error",
              content: deleteResponse?.data?.message,
              open: true,
            });
          }
        }
      });
    }
  };

  const [filterVal, setFilterVal] = useState({
    is_active: "",
  });

  const handleFilter = (accessor, value) => {
    setFilterLoader(true);
    setFilterVal({ ...filterVal, [accessor]: value });
    setDefaultFilter((prev) => ({ ...prev, currentPage: 1 }));
  };

  let Obj = {
    ...defaultFilter,
    filters: {
      name: filterVal?.name,
      is_active: filterVal?.is_active?.value,
    },
  };

  const getAddOnsList = async (data) => {
    let response = await addOnsList(Obj);
    filterLoader ? setIsLoading(false) : setIsLoading(true);
    if (response?.status === 200) {
      setIsLoading(false);
      setAddOnsData(response?.data?.data?.rows);
      setRowCount(response?.data?.data?.count);
    }
  };

  useEffect(() => {
    getModuleAccess(MODULES.AMENITY);
  }, [modules]);

  useEffect(() => {
    getAddOnsList();
  }, [filterVal, defaultFilter]);

  let data = {
    isFilter: true,
    columns: [
      {
        Header: "Name",
        accessor: "name",
        minWidth: "85px",
        sort: true,
        filterLabel: "Name",
        filterAccessor: "name",
        filterInputType: SEARCH_INPUT_TYPES.TEXT,
        filterHandleChange: handleFilter,
        Cell: ({ value }) => <DefaultCell value={value || "-"} />,
      },
      {
        Header: "Member Price",
        accessor: "member_price",
        minWidth: "85px",
        sort: true,
        Cell: ({ value }) => <div> {value}</div>,
      },
      {
        Header: "Non Member Price",
        accessor: "non_member_price",
        minWidth: "85px",
        sort: true,
        Cell: ({ value }) => <div> {value}</div>,
      },
      {
        Header: "Status",
        accessor: "is_active",
        // minWidth: "115px",
        sort: false,
        filterLabel: "Status",
        filterAccessor: "is_active",
        filterInputType: SEARCH_INPUT_TYPES.AUTO_COMPLETE,
        filterHandleChange: handleFilter,
        filterOption: [
          { label: "Active", value: "1" },
          { label: "Inactive", value: "0" },
        ],
        Cell: ({ row }) => (
          <UpdateStatus
            tableNameProp="amenity_addons"
            data={row}
            access={access?.write_access ? true : false}
          />
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        width: "12%",
        Cell: ({ value, row }) => (
          <MDBox sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {access?.write_access && (
              <MDActionButton type="edit" onClick={() => handleEditDelete(row?.original, "Edit")} />
            )}
            {access?.delete_access && (
              <MDActionButton
                type="delete"
                onClick={() => handleEditDelete(row?.original, "Delete")}
              />
            )}
          </MDBox>
        ),
      },
    ],
    rows: addOnsData,
  };

  return (
    !isLoading && (
      <DashboardLayout>
        <DashboardNavbar />
        <>
          <MDModal
            hasButton={access?.write_access ?? false}
            btnText="Add Add-Ons"
            modalHead={`${formIsEdit ? "Edit" : "Add"} Add-Ons `}
          >
            <AddOnsForm getAddOnsList={getAddOnsList} />
          </MDModal>
          <DataTable
            table={data}
            isSorted={false}
            entriesPerPage={true}
            showTotalEntries={true}
            noEndBorder
            canFilter
            canSearch={true}
            tableTitle="Add-Ons List"
            updateApi={updateAddOns}
            getDataList={getAddOnsList}
            rowCount={rowCount}
            // isDraggable={true}
            defaultFilter={defaultFilter}
            setDefaultFilter={setDefaultFilter}
          />
        </>
      </DashboardLayout>
    )
  );
};

AddOns.propTypes = {
  value: PropTypes.string,
  row: PropTypes.string,
  getAddOnsList: PropTypes.func,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddOns;
